<template>
  <main>
    <div class="main" v-if="!isArticel.status">
      <h1>{{ meanCenterObj.tabTitle }}</h1>
      <newA v-if="meanCenterObj.tabName == 'newA'" />
      <newB v-else />
    </div>
    <articel v-else />
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "news",
  data() {
    return {
      pageCount: 0,
    };
  },
  computed: mapGetters(["meanCenterObj",'isArticel']),
  created() {
     this.getCate({
      parent: this.meanCenterObj,
      _child: this.meanCenterObj._child[0],
    });
  },
  methods: {
    ...mapActions(["getCate"]),
  },
};
</script>
<style scoped lang='less'>
.container {
  max-width: 77.7vw;
  margin: 0 auto;
  > h1 {
    border-bottom: 1px solid #d7d7d7;
    padding-bottom:1vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue